import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import { useEffect, useState } from "react";

const CardSkeleton = styled(MUISkeleton)`
	transform: unset;
`;

const ControllerSkeleton = styled(MUISkeleton)`
	border-radius: 20px;
	transform: unset;
	width: 100%;
`;

const HintSkeleton = styled(MUISkeleton)`
	border-radius: 6px;
	transform: unset;
	margin: 0 auto;
`;

export function FlashcardCardSkeleton() {
	return <CardSkeleton variant="rounded" className="flashcard-skeleton-card" />;
}

export function FlashcardContentSkeleton() {
	return (
		<div className="flashcard-app" data-test-id="flashcard-content-skeleton">
			<div className="flashcard-app-box">
				<FlashcardCardSkeleton />
				<ControllerSkeleton variant="rounded" height={64} />
				<HintSkeleton variant="rounded" width={400} height={24} />
			</div>
		</div>
	);
}

interface DelayedFlashcardCardSkeletonProps {
	delayMs?: number;
}

export function DelayedFlashcardCardSkeleton({
	delayMs = 400,
}: DelayedFlashcardCardSkeletonProps) {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const id = setTimeout(() => setVisible(true), delayMs);
		return () => clearTimeout(id);
	}, [delayMs]);

	if (!visible) return null;
	return <FlashcardCardSkeleton />;
}
